import { gql } from "@apollo/client";

export const CREATE_BILLING_SESSION = gql`
  mutation CreateBillingSession($input: BillingSessionInput!) {
    createBillingSession(input: $input) {
      url
    }
  }
`;
